import clsx from "clsx";
import React from "react";

interface FieldValueProps {
  variant?: "stack" | "horizontal" | "colon";
  label: string;
  children?: React.ReactNode;
  value?: string | number;
  labelClassName?: string;
  valueClassName?: string;
  className?: string;
}
const FieldValue = ({
  variant = "stack",
  label,
  children,
  value,
  className,
  labelClassName,
  valueClassName,
}: FieldValueProps) => {
  return (
    <div
      className={clsx("text-black-900", className, {
        "flex items-center gap-2": variant !== "stack",
        "flex items-start": variant === "colon",
      })}
    >
      <h6
        className={clsx(labelClassName, {
          "text-black-600 mb-1": variant !== "colon",
          "w-32 flex-shrink-0 text-black-600": variant === "colon",
        })}
      >
        {label}
      </h6>
      {variant === "colon" && (
        <span className="text-black-600 font-normal flex-shrink-0 mr-2">:</span>
      )}
      <div
        className={clsx("break-words", valueClassName, {
          "font-medium": variant !== "colon",
          "flex-1": variant === "colon",
        })}
      >
        {value ?? children}
      </div>
    </div>
  );
};

export default FieldValue;
